import styled from 'styled-components';

import { Loader, LoaderModeType } from 'components/Loader';
import { TotemSelect } from 'components/TotemSelect';
import { formatDateForDisplay } from 'helpers/dateTimes';

import { useGetOrdersFromOrganizationQuery } from 'data/__generated__';

export function OrderSelector({
    organizationId,
    selectedOption,
    setSelectedOption,
}: {
    organizationId: string;
    selectedOption: string | null;
    setSelectedOption: (value: string | null) => void;
}) {
    const {
        loading: ordersLoading,
        data: ordersData,
        error: ordersError,
    } = useGetOrdersFromOrganizationQuery({
        variables: { organizationId },
    });

    if (ordersLoading) {
        return <Loader mode={LoaderModeType.Spin} />;
    }

    if (ordersError || !ordersData) {
        throw new Error('Une erreur est survenue lors de la récupération des organisations');
    }

    const ordersOptions = ordersData.activeOrdersFromOrganization
        .map((order) => ({
            value: order._id,
            label: `TOTEM #${order.totem.number} (${order.totem.name || 'sans nom'}) ● ${
                order.isPunctual ? 'Ponctuelle' : 'Récurrente'
            } ● Commande n°${order.number} ● ${formatDateForDisplay(order.deliveryDate)}`,
        }))
        .sort((orderA, orderB) => orderA.label.toLowerCase().localeCompare(orderB.label.toLowerCase()));

    return (
        <Container>
            <TotemSelect<string>
                label="Commande"
                placeholder="Sélectionner une commande"
                value={selectedOption}
                options={ordersOptions}
                onChange={setSelectedOption}
            />
        </Container>
    );
}

const Container = styled.div`
    /* These lines are a placeholder for the select options */
    min-width: 400px;
    min-height: 150px;
`;
